import * as React from 'react';
import { UIHeading4 } from '@cian/ui-kit';
import { IconCommunicationPhone16 } from '@cian/ui-kit-design-tokens/icons';
import * as style from './ContactsList.css';
import { ContactsListCallButton } from '../../../containers/PromoDetails/parts/ContactsListCallButton';
import { IBuilder } from '../../../types/newbuilding/builder';
import { ISeller } from '../../../types/newbuilding/seller';
import { Author } from '../Author';

interface IContactsListProps {
  builders: IBuilder[];
  sellers: ISeller[];
  onShowPhoneClick(): void;
}

export const ContactsList = ({ builders, sellers, onShowPhoneClick }: IContactsListProps) => {
  return (
    <div className={style['container']}>
      <div>
        <UIHeading4>Застройщики, участвующие в проекте</UIHeading4>
      </div>
      <div className={style['list']}>
        {builders.map(builder => (
          <Author
            key={builder.id}
            label="Застройщик"
            name={builder.name}
            contactsButton={
              <ContactsListCallButton
                onClick={onShowPhoneClick}
                beforeIcon={<IconCommunicationPhone16 color="icon-inverted-default" />}
                buttonText="Контакты застройщика"
                contact={builder}
              />
            }
          />
        ))}
        {sellers.map(seller => (
          <Author
            key={seller.name}
            label="Представитель застройщика"
            name={seller.name as string}
            contactsButton={
              <ContactsListCallButton onClick={onShowPhoneClick} buttonText="Контакты представителя" contact={seller} />
            }
          />
        ))}
      </div>
    </div>
  );
};
